<template>
  <div class="pending-prefix">
    <h6 class="title">Pending Approval</h6>
    <p>The UPI Prefix <b>{{prefixData.prefix}}</b> is pending approval.</p>
    <p>It might take upto 24 hours for approval from Hypto.</p>
    <p>Please reach out to <u>support@hypto.in</u> for any clarifications.</p>
  </div>
</template>

<script>
export default {
  name: 'PendingUpiPrefix',
  props: {
    prefixData: Object
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  .pending-prefix {
    background: $white;
    border-radius: 5px;

    .title {
      @include highlight-text($secondary, 15px);
      text-align: left;
    }
    p {
      @include normal-text($secondary, 14px, 400);
      text-align: left;
      margin-top: 10px;
    }
  }

  .desktop {
    .pending-prefix {
      width: 50%;
      padding: 25px;
      height: calc(100vh - 100px);
    }
  }

  .mobile, .tablet {
    .pending-prefix {
      padding: 15px;
    }
  }
</style>
